import { render, staticRenderFns } from "./ModalRelatoriosSolicitados.vue?vue&type=template&id=3264999e"
import script from "./ModalRelatoriosSolicitados.vue?vue&type=script&lang=js"
export * from "./ModalRelatoriosSolicitados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3264999e')) {
      api.createRecord('3264999e', component.options)
    } else {
      api.reload('3264999e', component.options)
    }
    module.hot.accept("./ModalRelatoriosSolicitados.vue?vue&type=template&id=3264999e", function () {
      api.rerender('3264999e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modals/ModalRelatoriosSolicitados.vue"
export default component.exports